import _ from "underscore";

import React from 'react';
import createReactClass from 'create-react-class';
import BaseMixin from './BaseMixin';
import StringCompareTerminalMixin from './StringCompareTerminalMixin';
import Styles from './../StyleSheet';

const StringListTerminal = createReactClass({
  displayName: 'StringListTerminal',
  mixins: [BaseMixin, StringCompareTerminalMixin],

  render: function() {
    return (
      <form className="form-inline">
        {this.renderTerminalName()}
        {this.renderRelOp({ hideContains: true, hidePresent: true })}
        {this._optionsFromList()}
      </form>
    );
  },

  _list: function() {
    return this.props.node.possibleValues();
  },

  _optionsFromList: function() {
    var options = [<option key='placeholder-option' value="" disabled>Select an Item</option>];
    options = options.concat(_.map(this._list(), function(val) {
      return <option key={val} value={ val.toLowerCase() }>{ val[0].toUpperCase() + val.substring(1) }</option>;
    }));

    return (
      <select
        className="form-control"
        style={this._optionsFromListStyles()}
        onChange={this._onValueChange}
        value={this.props.node.get('value').toLowerCase()}
        disabled={!this.props.editable}>
        {options}
      </select>
    );
  },

  _optionsFromListStyles: function() {
    return (
      _.extend(
        {},
        Styles.select,
        Styles.lastChild
      )
    );
  }
});

export default StringListTerminal;
